import React from "react";
var __jsx = React.createElement;
import { ModernCard } from "@/components/SearchComponent/ModernCard";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
var DealsSection = function DealsSection(_ref) {
  var posts = _ref.posts,
    _ref$sectionTitle = _ref.sectionTitle,
    sectionTitle = _ref$sectionTitle === void 0 ? "" : _ref$sectionTitle,
    _ref$sectionVariant = _ref.sectionVariant,
    sectionVariant = _ref$sectionVariant === void 0 ? "orange" : _ref$sectionVariant,
    ctaLink = _ref.ctaLink,
    _ref$sectionType = _ref.sectionType,
    sectionType = _ref$sectionType === void 0 ? "marketing_carousel1" : _ref$sectionType,
    _ref$ctaId = _ref.ctaId,
    ctaId = _ref$ctaId === void 0 ? "" : _ref$ctaId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!posts.length) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: twMerge("relative before:block before:content-[''] before:w-full before:h-[70%] before:bg-[#FFF2EE] before:absolute before:top-0 before:left-0 before:z-[-1] lg:before:h-[400px] lg:pb-0", sectionVariant === "orange" && "before:bg-[#FFF2EE]", sectionVariant === "blue" && "before:bg-[#F1F6FC]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-6 flex flex-col gap-6 z-[10] max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto lg:gap-[64px] lg:pt-[88px] lg:pb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 justify-center lg:w-[580px] lg:mx-auto px-4 lg:px-0 lg:mt-0 lg:gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-[12.5%] h-px bg-gradient-to-r from-transparent  to-primary max-w-16 transform rotate-180 en:rotate-0"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-primary font-bold text-base text-center lg:text-3xl"
  }, sectionTitle), /*#__PURE__*/React.createElement("div", {
    className: "flex-[12.5%] h-px bg-gradient-to-l from-primary  to-transparent max-w-16 en:rotate-180"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "flex gap-5 flex-nowrap overflow-auto px-4 snap-x snap-mandatory lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-0 lg:px-0"
  }, posts.length > 0 && (posts === null || posts === void 0 ? void 0 : posts.map(function (post, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: "flex-none snap-center min-h-full lg:w-full w-[300px]"
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      key: post.id,
      titleTag: "h3",
      rank: i + 1,
      sectionType: sectionType
    }));
  })), posts.length >= 4 && /*#__PURE__*/React.createElement("li", {
    className: "flex items-center justify-center rounded bg-[#3C56D4] shadow-md w-[165px] flex-none snap-center p-6 gap-1 md:hidden"
  }, /*#__PURE__*/React.createElement(Link, {
    to: ctaLink,
    className: "h-full flex items-center justify-center w-[165px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-white text-right text-base font-bold leading-6"
  }, t("إعرض المزيد من السيارات", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    className: "text-white text-right text-base font-bold leading-6 en:transform en:rotate-180",
    src: CDN_LINK + "/assets/images/arrow-left-white.svg",
    alt: "arrow-left-white"
  })))))), posts.length >= 4 && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex md:items-center md:justify-center md:mt-[56px]"
  }, /*#__PURE__*/React.createElement(Link, {
    to: ctaLink,
    className: "rounded bg-[#FE561C] w-[250px] h-[48px] p-4 text-center text-white text-sm font-bold leading-4 outline-none border-none cursor-pointer hover:text-white",
    id: "deal-section_cta-".concat(ctaId)
  }, t("اعرض الكل", {
    ns: "web_common"
  })))));
};
export default DealsSection;